module.exports = __webpack_public_path__ + "static/media/TN-Women-Pants-v2.0.8ee1c4bb.svg";